<template> 
  <div ref="ProfitLossDashboardpdf" id="ProfitLossDashboardpdf">
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <div class="gutr mt-3">
        <div class="row">
          <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
            <div>
              <b-navbar toggleable="lg" type="dark" variant="info">
                <b-navbar-brand style="padding: 0.475rem 1rem">
                  <transition name="custom-slide" mode="out-in">
                    <h3>CSO Dashboard</h3>
                  </transition>
                </b-navbar-brand>

                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button-group size="sm" class="ml-1 text-right">
                      <b-button variant="outline-secondary" @click="goBack"
                        >Back</b-button
                      >
                    </b-button-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>

              <div>
                <b-card>
                  <b-row>
                    <b-col md="12">
                      Data wef 1st Jan2023<br />
                      <div class="tab-list d-flex">
                        
                        <div
                          v-for="(tab, index) in tabs"
                          :key="index"
                          :class="{ 'active-tab': activeTab === index }"
                          @click="changeTab(index)"
                        >
                          {{ tab.name }}
                        </div>
                      </div>

                      <transition name="custom-slide" mode="out-in">
                        <component :is="currentTabComponent" :key="activeTab"></component>
                      </transition>
                      <!-- <div class="tab-content">
                      <component :is="currentTabComponent"></component>
                    </div> -->
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <md-dialog-confirm
        :md-content-html="alert.content"
        :md-ok-text="alert.ok"
        ref="addPop"
      ></md-dialog-confirm>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import ProfitLossService from "../../services/ProfitLossService.js";
import PLTable from "../common/plTable.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";

import NinghtyDayTab from "./ninghtyDayTab.vue";
import AirExp from "./AirExp.vue";
import AirImp from "./AirImp.vue";
import SeaExp from "./SeaExp.vue";
import FFSeaExp from "./FFSeaExp.vue";
import CCSeaExp from "./CCSeaExp.vue";
import TPTSeaExp from "./TPTSeaExp.vue";
import SeaImp from "./SeaImp.vue";
import FFSeaImp from "./FFSeaImp.vue";
import CCSeaImp from "./CCSeaImp.vue";
import TPTSeaImp from "./TPTSeaImp.vue";
import AllClient from "./allClient.vue";
import FFOnlyCT from "./FFOnlyCT.vue";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (
        globalPermissionStatus("Accounts") ||
        globalPermissionStatus("Dashboard_Access")
      ) {
        this.$store.dispatch("setCurrentRoute", "/pendClient");

        // this.getProfitLossData("Normal");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      activeTab: 0,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      tabs: [
        { name: "90 Days Tab", component: NinghtyDayTab },
        { name: "Air Exp", component: AirExp },
        { name: "Air Imp", component: AirImp },
        { name: "Sea Exp", component: SeaExp },
        { name: "FF Sea Exp", component: FFSeaExp },
        { name: "CC Sea Exp", component: CCSeaExp },
        { name: "TPT Sea Exp", component: TPTSeaExp },
        { name: "Sea Imp", component: SeaImp },
        { name: "FF Sea Imp", component: FFSeaImp },
        { name: "CC Sea Imp", component: CCSeaImp },
        { name: "TPT Sea Imp", component: TPTSeaImp },
        { name: "Not Used Client", component: AllClient },
        { name: "FF Imp/Exp (CT, TPT, CC)", component: FFOnlyCT },
      ],
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
    };
  },
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component;
    },
  },
  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},

  destroyed() {},
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}

.tab-list {
  display: flex;
  cursor: pointer;
  overflow-x: auto;
}

.tab-list div {
  padding: 10px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.3s;
}

.tab-list div:hover {
  background-color: #0aa46e;
}

.active-tab {
  background-color: #007bff;
  color: #ffffff;
}

.tab-content {
  margin-top: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-slide-enter-active,
.custom-slide-leave-active {
  transition: transform 0.5s;
}

.custom-slide-enter,
.custom-slide-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// Tab.vue?28f822b6